import { render } from "./LatestSinglePost.vue?vue&type=template&id=200f175c&scoped=true"
import script from "./LatestSinglePost.vue?vue&type=script&lang=js"
export * from "./LatestSinglePost.vue?vue&type=script&lang=js"

import "./LatestSinglePost.vue?vue&type=style&index=0&id=200f175c&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200f175c"]])

export default __exports__